import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** PALZ（美食のんびり族）— デザイン確定済み・他タイプの参考実装 */
const palzContent: DiagnosisResultContent = {
  code: 'PALZ',
  name: '美食のんびり族',
  catchphrase: '一日中レストランにいるタイプ',
  rarity: 4,
  style:
    '「ゆっくり、じっくり味わう」ことが旅の核心。料理を食べるだけでなく、器・空間・会話・音楽も含めて食体験として楽しむ。時間が溶けたような至福の時間を味わう。一つ一つ、カフェで本を読んだり散策したり、一緒にいるだけで食が豊かになる、稀有な旅の達人。',
  strengths: [
    { lead: '食の満足度が高い', text: '量より質・速度より体験を重視し、記憶に残る旅に。' },
    { lead: '旅の時間が豊か', text: '焦らず過ごすことで、旅行に「余白の時間」を楽しめる。' },
    { lead: '記憶に残る体験型グルメが得意', text: '食の文脈に乗せた体験は記憶に残りやすい。' },
  ],
  weaknesses: [
    { lead: '行動量が多い旅は苦手', text: '動き回ることが目的化すると、食の余白が消える。' },
    { lead: '急かされると一気に萎える', text: '時間プレッシャーの中での食事は味も楽しさも半減。' },
    { lead: '予約が取れないと困る', text: '行きたい店が確保できないと代替案が浮かびにくい。' },
  ],
  aaru: [
    { icon: 'utensils', text: '1食が主役' },
    { icon: 'coffee', text: 'カフェで時間が溶ける' },
    { icon: 'camera', text: '観光より店の雰囲気' },
    { icon: 'utensils', text: '写真が料理だけ' },
    { icon: 'msg', text: '「次どこ食べる？」が口癖' },
  ],
  manual: {
    good: 'ゆっくりに付き合う／「美味しいね」共感',
    ng: '「早く食べよう」「時間いっぱいです」',
    tips: '観光は「短く濃く」1日1〜2個がベスト',
  },
  compatibility: {
    good: 'PALE（食仲間）／PRLZ（隠居旅人）',
    conflict: 'PACE（完璧弾丸）／SALE（爆速即興）',
    tips: '午前到着／合意地点だけ決める',
  },
  destinations: {
    domestic: '京都（老舗と路地裏）／北陸（金沢・富山）',
    overseas: 'イタリア（食文化の深さ）／スペイン（バル文化）',
  },
};

export const palzDiagnosisResult = buildDiagnosisResult(palzContent);
